import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import DataListItem from './DataListItem.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinDataList",
  slot: "Root"
});

var DataListBase = function DataListBase(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("dl", {
    className: classnames(componentRoot.className, className)
  }, children);
};

DataListBase.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var DataListRoot = styled(DataListBase, componentRoot.styledOptions)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    margin: theme.spacing(-1),
    flex: 1
  };
});
/**
 * Creates a styled `dl` element that displays a list of data
 */

var DataList = function DataList(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(DataListRoot, rootProps);
};
/** A single item for a `dt` & `dd` element pair */


DataList.Item = DataListItem;
var DataList$1 = DataList;

export { DataList$1 as default };
